import { assert, CheckedAddress } from '@sparkdotfi/common-universal'

import { getChainConfigEntry } from '@/config/chain'
import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { useTokenRepository } from '@/domain/token-repository/useTokenRepository'

export type SavingsTokenRepository = TokenRepository

export interface UseSavingsTokenRepositoryParams {
  chainId: number
  account: CheckedAddress | undefined
}

export function useSavingsTokenRepository({
  chainId,
  account,
}: UseSavingsTokenRepositoryParams): SavingsTokenRepository {
  const chainConfig = getChainConfigEntry(chainId).savings
  assert(chainConfig, 'Savings config not available for this chain')

  return useTokenRepository({ chainId, priceConfigs: chainConfig.priceConfigs, account })
}
